/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState, useCallback } from "react";
import { List, ListItem, ListItemText, ListSubheader, Button, TextField } from "@material-ui/core";
import { ConfirmDialog } from "../../../../components/ConfirmDialog/ConfirmDialog";

/**
 *
 * @param {String} sourceLanguage eg: 'en'
 * @param {[{[languageCode]: String}]} translationsData
 */
export const LangTermList = ({
	sourceLanguage,
	translationsData,
	setFormEdited,
	addTermHandler,
	selectTermHandler,
	activeTerm,
	formEdited,
}) => {
	const [searchTerm, setSearchTerm] = useState("");
	const [editConfirmOpen, setEditConfirmOpen] = React.useState(false);
	const [term, setTerm] = useState(null);

	const sourceLanguageCode = sourceLanguage?.languageCode;

	const handleSearchChange = useCallback((e) => {
		setSearchTerm(e.target.value);
	}, []);

	const handleConfirm = (confirmed) => {
		if (confirmed) {
			setFormEdited(false);
			selectTermHandler({ isNew: false, term: term.map((t) => ({ ...t })) });
		}
		setEditConfirmOpen(false);
	};

	const handleListItemClick = (term) => {
		setTerm(term);
		formEdited ? setEditConfirmOpen(true) : selectTermHandler({ isNew: false, term: term.map((t) => ({ ...t })) });
	};

	const searchMatches =
		translationsData?.filter((row) => {
			return !!(row.find((term) => term.languageCode === sourceLanguageCode)?.value || "")
				?.toLowerCase()
				?.includes(searchTerm?.toLowerCase());
		}) || [];

	return (
		<div>
			<List
				className="w-100"
				subheader={
					<ListSubheader disableSticky component="div">
						<div style={{ marginBottom: 8 }}>
							<TextField
								style={{ width: "100%" }}
								size="small"
								label="Search terms"
								value={searchTerm}
								onChange={handleSearchChange}
							/>
						</div>
						<div className="d-flex flex-row justify-content-between align-items-center flex-wrap">
							{sourceLanguage?.displayName && <span>{sourceLanguage?.displayName} Terms</span>}
							<Button
								variant="outlined"
								className="mb-2 mb-md-0"
								size="small"
								disabled={!!activeTerm && formEdited}
								onClick={() => addTermHandler()}
							>
								Add
							</Button>
						</div>
					</ListSubheader>
				}
			>
				{searchMatches.length > 0 ? (
					searchMatches.map((term) => {
						const { value: termValue = "", id: termId } = term.find((t) => t.languageCode === sourceLanguageCode) || {};
						const isSelected =
							activeTerm && termId === activeTerm.find((s) => s.languageCode === sourceLanguageCode)?.id;
						return (
							<ListItem button selected={isSelected} onClick={() => handleListItemClick(term, termId)} key={termId}>
								<ListItemText
									style={{ overflowWrap: "break-word", opacity: termValue === "" ? 0.2 : 1 }}
									primary={termValue ? termValue : `<empty>`}
								/>
							</ListItem>
						);
					})
				) : (
					<ListItem>
						<span className="text-muted font-italic">
							{!searchTerm ? "No terms yet, click the 'Add' button to create a new one." : "No terms found."}
						</span>
					</ListItem>
				)}
			</List>
			<ConfirmDialog
				title={"Switch Term?"}
				message={"You have unsaved changes that will be discarded if you proceed. Are you sure?"}
				confirmOpen={editConfirmOpen}
				onClose={handleConfirm}
			/>
		</div>
	);
};
